import { call, put, takeEvery } from "redux-saga/effects";
import { deleteAccountRequest, deleteAccountSuccess, deleteAccountFailure } from "../slice/deleteAccountSlice";
import { deleteAccount as deleteAccountApi } from "@src/api/apiService"; // Implement this API function
import { getApiError } from "@src/utils/apiError";

export function* deleteAccount(): Generator<any, void, any> {
    try {
        yield call(deleteAccountApi);
        yield put(deleteAccountSuccess());
    } catch (error: unknown) {
        const apiError = getApiError(error);
        yield put(
            deleteAccountFailure(
                apiError.message
            )
        );
    }
}

export function* deleteAccountSaga() {
    yield takeEvery(deleteAccountRequest.type, deleteAccount);
}
